import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { DEFAULT_FONT_FAMILY } from '@constants/common/ui.constants';

interface Params {
  isError: boolean;
}

const useStyles = makeStyles<Params>()((theme, { isError }) => ({
  root: {
    width: '100%',
    position: 'relative',
  },

  formControl: {
    width: '100%',
  },
  disabledBox: {
    opacity: 0.38,
    pointerEvents: 'none',

    '& .MuiFormHelperText-root': {
      span: {
        color: theme.palette.custom.text.white,
      },
    },
  },
  input: {
    background: theme.palette.custom.elements.primary,
    transition: 'all 0.25s ease-in-out',
    borderRadius: theme.borderRadius.md,

    '& input': {
      boxSizing: 'border-box',
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 400,
      fontFamily: DEFAULT_FONT_FAMILY,
      color: theme.palette.custom.text.white,
      height: 45,
      borderRadius: theme.borderRadius.md,

      '&.MuiInputBase-inputSizeSmall': {
        height: 44,
        minHeight: 44,
      },

      '&::placeholder': {
        fontSize: 14,
        color: theme.palette.custom.text.light,
        opacity: 1,
      },

      '&:focus': {
        caretColor: theme.palette.custom.text.white,
        backgroundColor: theme.palette.custom.elements.secondary,
      },

      '&:hover': {
        color: theme.palette.custom.text.white,
        backgroundColor: theme.palette.custom.elements.secondary,
      },
    },

    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.custom.border.primary}`,
        color: theme.palette.custom.text.white,

        '& input': {
          color: theme.palette.custom.text.white,
        },
      },

      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',

        '& input': {
          color: theme.palette.custom.text.white,
        },
      },
    },

    '&:hover': {
      '& input': {
        color: theme.palette.custom.text.white,

        '&::placeholder': {
          color: theme.palette.custom.text.light,
        },
      },

      '& .MuiSvgIcon-root': {
        color: theme.palette.custom.text.white,
      },
    },
  },
  supportText: {
    paddingTop: 4,
    lineHeight: 1,
  },

  error: {
    right: 0,
    marginRight: 'auto',

    '& span': {
      color: theme.palette.custom.accent.error,
    },
  },
  errorBox: {
    '.MuiFormLabel-root': {
      color: theme.palette.custom.text.light,
    },

    '&:hover .MuiFormLabel-root': {
      color: theme.palette.custom.text.light,
    },

    '& .MuiFormLabel-root': {
      color: theme.palette.custom.text.light,

      '&.Mui-focused': {
        color: theme.palette.custom.text.light,
        backgroundColor: theme.palette.custom.elements.secondary,
      },
    },

    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.accent.error,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.accent.error,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.custom.accent.error} !important`,
      },
    },

    '& input': {
      color: theme.palette.custom.text.white,
      caretColor: `${theme.palette.custom.text.white} !important`,
    },
  },

  buttonMax: {
    textTransform: 'capitalize',
    backgroundColor: 'transparent',
    border: 'none',
    // Sky DS input MAX action: Text/Light (empty state tone)
    color: theme.palette.custom.text.light,
    cursor: 'pointer',

    '&:hover': {
      opacity: '0.7',
    },

    '&:active': {
      opacity: '0.5',
    },

    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.38,
    },
  },

  searchIcon: {
    ...dFlex(),
    color: theme.palette.custom.text.white,
    width: 28,
  },
  actionsBox: {
    ...dFlex(),
    gap: 12,
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translate(0, -50%)',

    ...(isError && {
      top: '33%',
      transform: 'translate(0, -50%)',
    }),
  },
}));

export default useStyles;
